import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { backend_url } from '../config/url.config';

@Injectable({
    providedIn: 'root'
})
export class CovidMedicalConsultantsService {

    readonly URL_API = backend_url + '/api/escuelas/';

    constructor(private http: HttpClient) { }

    getMedicalConsultants(municipality) {
        return this.http.post(this.URL_API, {
            "entidad_cvegeo": municipality
        });
    }
}
